var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 31,
    viewBox: "0 0 24 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3073 10.626H19.1494C18.5746 10.626 18.1083 10.1678 18.1083 9.60197V5.70946C18.1083 4.316 16.96 3.18654 15.5434 3.18654H8.36941C6.95275 3.18654 5.80449 4.316 5.80449 5.70946V9.60197C5.80449 10.1674 5.33868 10.626 4.76341 10.626H3.60553C3.03072 10.626 2.56445 10.1678 2.56445 9.60197V5.70946C2.56445 2.55626 5.16326 0 8.36895 0H15.5429C18.7486 0 21.3474 2.55626 21.3474 5.70946V9.60197C21.3479 10.1678 20.8821 10.626 20.3073 10.626Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7422 11.5449H2.17147C0.972374 11.5449 0 12.5014 0 13.6808V28.4548C0 29.6343 0.972374 30.5907 2.17147 30.5907H21.7422C22.9413 30.5907 23.9137 29.6343 23.9137 28.4548V13.6808C23.9137 12.5014 22.9413 11.5449 21.7422 11.5449ZM14.757 25.8242C14.8783 26.322 14.495 26.8005 13.9747 26.8005H9.93905C9.41874 26.8005 9.03537 26.322 9.15675 25.8242L10.0984 21.9686C8.98682 21.3149 8.25994 20.0931 8.3346 18.7105C8.43079 16.9196 9.90607 15.4541 11.7253 15.3428C13.8336 15.214 15.5846 16.8579 15.5846 18.9042C15.5846 20.2067 14.8747 21.3456 13.8153 21.9686L14.757 25.8242Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.9a65a12cdf0c1560784b4c6d4372b1da.svg";
export { ForwardRef as ReactComponent };